import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";

const KEY = "footsie_founding_banner_dismissed";

export default function FoundingBanner() {
    const [dismissed, setDismissed] = React.useState(() => {
        try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
    });
    if (dismissed) return null;

    const dismiss = (e) => {
        e.preventDefault();
        e.stopPropagation();
        try { localStorage.setItem(KEY, "1"); } catch (_) { /* ignore */ }
        setDismissed(true);
    };

    return (
        <div
            className="relative brut-static bg-[#FFE55C] rounded-xl px-4 py-3 sm:py-4 flex items-center gap-3 mb-6"
            data-testid="founding-banner"
        >
            <div className="w-10 h-10 rounded-lg bg-white border-2 border-[#0A0A0A] flex items-center justify-center shrink-0">
                <Sparkles className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
                <div className="text-[10px] font-black uppercase tracking-widest text-[#0A0A0A]/70 mb-0.5">Founding Member · Launch offer</div>
                <div className="font-black text-sm sm:text-base leading-tight">
                    Get <span className="bg-[#FFB8D1] px-1.5 rounded border-2 border-[#0A0A0A]">20% off</span> Pod Member yearly — forever. Use code <span className="serif italic font-normal">FOUNDING</span> at checkout.
                </div>
            </div>
            <Link
                to="/pricing"
                className="px-3 py-2 rounded-lg brut bg-[#0A0A0A] text-white font-bold text-xs sm:text-sm shrink-0"
                data-testid="founding-cta"
            >
                Claim
            </Link>
            <button
                onClick={dismiss}
                className="p-1 shrink-0 hover:bg-[#0A0A0A]/10 rounded"
                aria-label="Dismiss"
                data-testid="founding-dismiss"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}
